module.exports = __webpack_public_path__ + "img/50.337eb197.png";